function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxSnowLastHour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.14 109.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.93,90.48,48.72,86.9l3.72-1.61a2.57,2.57,0,0,0-2-4.72l-7.22,3.12-9.6-5.55,9.6-5.54,7.22,3.12a2.57,2.57,0,0,0,2-4.72l-3.72-1.61,6.21-3.58a2.57,2.57,0,1,0-2.57-4.45l-6.21,3.58.47-4a2.57,2.57,0,1,0-5.11-.58l-.91,7.81L31,73.69V62.6l6.3-4.69a2.57,2.57,0,1,0-3-4.13L31,56.19V49a2.57,2.57,0,0,0-5.14,0v7.17L22.6,53.78a2.57,2.57,0,1,0-3.05,4.13l6.31,4.69V73.69l-9.61-5.54-.91-7.81a2.57,2.57,0,1,0-5.11.58l.47,4L4.49,61.36a2.57,2.57,0,0,0-2.57,4.45l6.21,3.58L4.41,71a2.57,2.57,0,0,0,2.05,4.72l7.22-3.12,9.61,5.54-9.61,5.55L6.46,80.57a2.57,2.57,0,0,0-2,4.72L8.13,86.9,1.92,90.48a2.57,2.57,0,0,0,1.29,4.8,2.5,2.5,0,0,0,1.28-.35l6.21-3.58-.47,4a2.57,2.57,0,1,0,5.11.58l.91-7.81,9.61-5.54V93.69l-6.31,4.69a2.57,2.57,0,1,0,3.05,4.13l3.26-2.41v7.17a2.57,2.57,0,1,0,5.14,0V100.1l3.25,2.41a2.57,2.57,0,1,0,3-4.13L31,93.69V82.6l9.6,5.54L41.51,96a2.57,2.57,0,1,0,5.11-.58l-.47-4,6.21,3.58a2.52,2.52,0,0,0,1.28.35,2.57,2.57,0,0,0,1.29-4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,59.62a3.5,3.5,0,0,1-3.5-3.5V30.2l-1.39,1.22a3.5,3.5,0,1,1-4.61-5.26l7.2-6.3a3.49,3.49,0,0,1,5.8,2.63V56.12A3.5,3.5,0,0,1,67.76,59.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93,44.2H42.6a3.5,3.5,0,0,1,0-7h8.33a3.5,3.5,0,0,1,0,7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,34a3,3,0,0,0-4.2-.59l-6.88,5.2-3.16-.36-5.31-7A3,3,0,0,0,.6,34.82L9,46a3,3,0,0,0,1.62,1.09l.11,0a2.93,2.93,0,0,0,.41.07l.12,0h.39a3.4,3.4,0,0,0,.46-.06h0a3,3,0,0,0,1.36-.74l10.87-8.16a4.4,4.4,0,0,0,.39-.35A3,3,0,0,0,25,34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.47,8.46a3,3,0,0,0,1,.19,3,3,0,0,0,1-5.81c-1-.37-2-.71-3-1h0c-1.27-.37-2.58-.7-3.88-1a3,3,0,0,0-1.21,5.88c1.14.23,2.28.52,3.39.85C67.71,7.84,68.6,8.14,69.47,8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.63,14A40.7,40.7,0,0,1,84,17.79a3,3,0,1,0,4.23-4.26,47.26,47.26,0,0,0-5-4.34A3,3,0,1,0,79.63,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58,75.38a41.71,41.71,0,0,1-4.33,3.87,3,3,0,0,0,1.84,5.37A2.92,2.92,0,0,0,83.92,84a46.29,46.29,0,0,0,5-4.43,3,3,0,0,0-4.3-4.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.27,34.21a2.86,2.86,0,0,0,1.07-.2,3,3,0,0,0,1.73-3.87,47,47,0,0,0-2.8-6A3,3,0,1,0,91,27a41.15,41.15,0,0,1,2.45,5.26A3,3,0,0,0,96.27,34.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,43.09a3,3,0,0,0-6,.48c.08,1.08.13,2.19.13,3.29,0,.84,0,1.68-.08,2.52a3,3,0,0,0,2.82,3.17h.18a3,3,0,0,0,3-2.82q.09-1.44.09-2.88C102.14,45.6,102.09,44.33,102,43.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,58.91a3,3,0,0,0-3.83,1.8A40.45,40.45,0,0,1,91.39,66a3,3,0,1,0,5.3,2.81,47.15,47.15,0,0,0,2.69-6.09A3,3,0,0,0,97.57,58.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.16,85c-.86.34-1.74.66-2.63.94a3,3,0,0,0,.9,5.86,3.13,3.13,0,0,0,.9-.14c1-.32,2-.68,3-1.07A3,3,0,0,0,70.16,85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52,44.7l-.35,0a3,3,0,0,1-2.63-3.33A46.92,46.92,0,0,1,52,0a3,3,0,1,1,.41,6A40.91,40.91,0,0,0,14.5,42.05,3,3,0,0,1,11.52,44.7Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxSnowLastHour);
export default __webpack_public_path__ + "static/media/tx_SnowLastHour.4d77c17726d7cfa9f1712f3012e8d94c.svg";
export { ForwardRef as ReactComponent };